import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

const SearchBox = ({ 
  value, 
  onChange, 
  onSearch,
  placeholder = 'Search...', 
  title,
  className = '',
  maxWidth = 'max-w-xs',
  disabled = false
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!disabled && onSearch) {
      onSearch(value);
    }
  };

  return (
    <div className={`flex flex-col ${maxWidth} ${className}`}>
      {title && (
        <label className={`block text-label font-medium ${disabled ? 'text-gray-400' : 'text-gray-700'} mb-2`}>
          {title}
        </label>
      )}
      <form className="relative flex items-center z-10">
        <input
          type="text"
          value={value}
          onChange={(e) => !disabled && onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          className={`w-full h-10 px-3 text-base ${disabled ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-700'} rounded-md border-0
                   ring-1 ring-inset ${disabled ? 'ring-gray-200' : 'ring-gray-300'} outline-none
                   placeholder-gray-500
                   ${!disabled ? 'focus:outline-none focus:ring-2 focus:ring-inset focus:ring-brand-teal focus:border-brand-teal' : ''}
                   focus:outline-0`}
        />
        <button
          type="submit"
          onClick={handleSubmit}
          disabled={disabled}
          className={`absolute right-2 p-1.5 ${disabled ? 'text-gray-300 cursor-not-allowed' : 'text-gray-400 hover:text-gray-600'} focus:outline-none`}
          aria-label="Search"
        >
          <MagnifyingGlassIcon className="h-5 w-5" />
        </button>
      </form>
    </div>
  );
};

export default SearchBox; 